import React from "react";

import haf from "./images/havko.png";
import Background01 from "../src/images/background01.png";
import Background02 from "../src/images/background02.png";
import Logo from "../src/images/logo.png";
import "../src/styles/Background.scss";
import "../src/styles/CheckEmailError.scss";
import "../src/styles/SuccessPage.scss";
import { useTranslation } from "react-i18next";

import { useNavigate } from "react-router-dom";
function SucessPage() {
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate("/");
  };
  const { t } = useTranslation();
  return (
    <div className="content2">
      <img className="background01" src={Background01} alt="waves orange" />
      <img
        onClick={handleNavigate}
        className="background02"
        src={Background02}
        alt="waves blue"
      />
      <img className="logo2" src={Logo} alt="zooza logo" />
      <div className="middle">
        <img className="havko" src={haf} alt="hafko" />
        <h1 style={{ margin: 20 }}> {t("signup__thank")}</h1>
        <h3 style={{ margin: 20, textAlign: "center" }}>
          {t("signup__success_message")}
        </h3>
        <h4>{t("signup__alternative_login")}</h4>
        <a className="button-SignIn" href="https://app.zooza.sk/#/login">
          {t("signup__button_SignIn")}
        </a>
      </div>
    </div>
  );
}

export default SucessPage;
